<script setup>
import Dashboard from '../pages/Dashboard.vue';

import { reactive, onMounted, defineEmits, computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useRouter } from 'vue-router';
import { useToast } from 'primevue/usetoast';
import { useConfirm } from 'primevue/useconfirm';

import { useDashboardStore } from '../store/dashboard';
import { buildPagination, getPage, getPerPage, setPage, setPerPage } from '@/composables/PaginationComposable';

const router = useRouter();
const toast = useToast();
const confirm = useConfirm();
const dashboardStore = useDashboardStore();

const { dashboards, totalDashboards } = storeToRefs(dashboardStore);

const pageList = 'dashboardList';

const offset = computed(() => {
    console.log('offset::computed', getPage(pageList), getPerPage(pageList))
    return getPage(pageList) * getPerPage(pageList)
})

const numberOfRows = computed(() => {
    return getPerPage(pageList)
})

const emit = defineEmits(['updateDashboard']);

const createUpdateDashboard = (dashboardId) => {
    emit('updateDashboard', dashboardId);
}

const createInitialState = () => {
    return reactive({
        loading: false,
        previewDashboard: false,
        previewDashboardId: null,
        lazyParams: {
            first: 0,
            rows: 10,
            page: 1,
        },
    });
};
const state = createInitialState();

onMounted(async () => {
    buildPagination(pageList, 0, 10, [{field: "id", order: -1}])
    await loadDashboards(pageList);
});

const loadDashboards = async (pageList) => {
    state.loading = true;
    await dashboardStore.getDSDashboards(state.lazyParams, pageList);
    state.loading = false;
};

const onPage = async (event) => {
    state.lazyParams = event;
    setPage(pageList, event.page)
    setPerPage(pageList, event.rows)
    await loadDashboards(pageList);
};

const operateDashboard = (id, mode) => {
    switch (mode) {
        case 'edit':
            router.push({ name: 'EditDashboard', params: { id } });
            break;
        case 'delete':
            confirmOpt(id, 'delete');
            break;
        case 'view':
            state.previewDashboardId = id;
            state.previewDashboard = true;
            break;
        case 'default':
            confirmOpt(id, 'default');
            break;
    }
};

const confirmOpt = (id, mode) => {
    const header = mode === 'delete' ? 'Delete' : 'Default';
    const message = mode === 'delete' ? 'delete the dashboard' : 'set this dashboard as default';
    confirm.require({
        header: header + ' Confirmation',
        message: 'Are you sure you want to ' + message + '?',
        icon: 'pi pi-info-circle',
        accept: async () => {
            mode === 'delete' ? deleteDashboard(id) : dashboardStore.setDefaultDashboard(id);
        },
        reject: () => {
            toast.add({ severity: 'error', summary: 'Rejected', detail: 'Cancelled', life: 5000 });
        },
    });
};

const deleteDashboard = async (id) => {
    await dashboardStore.deleteDashboard(id);
    await loadDashboards();
};
</script>

<template>
    <div class="card">
        <DataTable
            v-model:first="offset"
            :rows="numberOfRows"
            :paginator="true"

            :value="dashboards"
            :lazy="true"
            selectionMode="single"
            :loading="state.loading"
            @page="onPage"
            dataKey="id"
            :totalRecords="totalDashboards"
            responsiveLayout="scroll"
            :rowsPerPageOptions="[5, 10, 20, 50]"
            paginatorTemplate="CurrentPageReport JumpToPageInput FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries :: Page No:"
        >
            <template #empty> No dashboards available </template>
            <template #loading> Loading dashboards. Please wait... </template>
            <Column field="id" header="ID" />
            <Column field="name" header="NAME" />
            <Column field="description" header="DESCRIPTION" />
            <Column field="metrics_count" header="DETAILS COUNT" />
            <Column field="default_dashboard" header="DEFAULT" />
            <Column field="order" header="ORDER" />
            <Column field="actions" header="ACTIONS" style="width: 16rem">
                <template #body="slotProps">
                    <!--<Button icon="pi pi-eye" class="p-button-rounded p-button-info mr-2" @click="operateDashboard(slotProps.data.id, 'view')" v-tooltip="'View Dashboard'" />-->
                    <!--<Button v-if="slotProps.data.editable" icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2" @click="operateDashboard(slotProps.data.id, 'edit')" v-tooltip="'Edit Dashboard'" />-->
                    <Button v-if="slotProps.data.editable" icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2" @click="createUpdateDashboard(slotProps.data.id)" v-tooltip="'Edit Dashboard'" />
                    <Button v-if="slotProps.data.deletable" icon="pi pi-trash" class="p-button-rounded p-button-danger mr-2" @click="operateDashboard(slotProps.data.id, 'delete')" v-tooltip="'Delete Dashboard'" />
                    <!--<Button v-if="slotProps.data.default" icon="pi pi-check" class="p-button-rounded p-button-help mr-2" @click="operateDashboard(slotProps.data.id, 'default')" v-tooltip="'Set Default'" />-->
                </template>
            </Column>
        </DataTable>

        <!-- For dashboard preview -->
        <!-- :contentStyle="{ height: '72vh' }" -->
        <Dialog v-model:visible="state.previewDashboard" header="Dashboard Preview" :style="{ width: '80vw' }" maximizable modal>
            <dashboard :id="state.previewDashboardId" />
        </Dialog>
    </div>
</template>
